import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { FormErrorComponent } from '../../form-error/form-error.component';
import { PostalCodeInputComponent } from '../../inputs/postal-code-input/postal-code-input.component';
import { CountryHelper, CountryType } from '../../../../../core';

@Component({
  selector: 'lib-postal-code-form-field',
  imports: [ReactiveFormsModule, PostalCodeInputComponent, FormErrorComponent],
  templateUrl: './postal-code-form-field.component.html',
  styleUrl: './postal-code-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostalCodeFormFieldComponent {
  protected readonly CountryHelper = CountryHelper;
  inputFormControl = input.required<FormControl>();
  label = input<string | null | undefined>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  countryType = input<CountryType | number | null>(CountryHelper.defaultCountry);
  inputId: string = uuidv4();

  protected readonly resolvedLabel = computed(() => {
    const label = this.label();
    if (label) return label;
    // change to switch if there is a plan to support more than 2 countries.
    return (this.countryType() ?? CountryHelper.defaultCountry) === CountryType.Canada
      ? $localize`Postal Code`
      : $localize`Zip Code`;
  });

  protected readonly resolvedPlaceholder = computed<string>(() => {
    const placeholder = this.placeholder();
    if (placeholder) return placeholder;
    return (this.countryType() ?? CountryHelper.defaultCountry) === CountryType.Canada ? 'A1A 1A1' : '12345';
  });
}
